export default __webpack_public_path__ + "static/media/style.12e5632d.less";